/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Select, { components, ControlProps } from 'react-select';
import { MdSort } from 'react-icons/md';

export type SortFields = {
  field: string;
  value: string;
  label: string;
  order: 'asc' | 'desc';
  type: 'text' | 'number' | 'date';
};

export type SortDropdownProps = {
  fields: SortFields[];
  value: string;
  order: 'asc' | 'desc';
  type: 'text' | 'number' | 'date';
  handleSort: ({
    field,
    order,
    type
  }: {
    field: string;
    order: 'asc' | 'desc';
    type: 'text' | 'number' | 'date';
  }) => void;
};

const Control = ({ children, ...props }: ControlProps<SortFields, false>) => {
  const iconStyle = { margin: '0 -8px 0 8px' };
  const iconProps = { size: 18, style: iconStyle };

  return (
    <components.Control {...props}>
      <MdSort {...iconProps} />
      {children}
    </components.Control>
  );
};

const SortDropdown = ({
  fields,
  handleSort,
  order,
  type,
  value
}: SortDropdownProps) => {
  const selectedValue = fields.find(
    (d) => d.field === value && d.order === order
  );

  const handleOnChange = (selected) => {
    handleSort({
      field: selected.field,
      order: selected.order,
      type: selected.type
    });
  };

  return (
    <Select
      closeMenuOnSelect
      order={order}
      type={type}
      options={fields}
      onChange={handleOnChange}
      value={selectedValue}
      components={{ Control }}
      isSearchable={false}
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: '80px',
          fontSize: 14,
          height: 34,
          minWidth: '230px',
          display: 'flex'
        }),
        placeholder: (base) => ({
          ...base,
          color: '#B1B1B1'
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: 'none'
        }),
        option: (base) => ({
          ...base,
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 12,
          paddingBottom: 12,
          fontSize: 12
        }),
        menuList: (base) => ({
          ...base,
          paddingTop: 12,
          paddingBottom: 12
        }),
        menu: (base) => ({
          ...base,
          zIndex: 999
        }),
        singleValue: (base) => ({
          ...base,
          maxWidth: '100%',
          fontSize: 12,
          fontWeight: 700
        })
      }}
    />
  );
};

export default SortDropdown;
